// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import constants from "@store/constants";
import applyDraftParameter from "@store/Framework/Store/Greif/Pages/OrderHistory/Handlers/ApplyDraftParameter";
import cancelDraftParameterChanges from "@store/Framework/Store/Greif/Pages/OrderHistory/Handlers/CancelDraftParameterChanges";
import clearDraftParameter from "@store/Framework/Store/Greif/Pages/OrderHistory/Handlers/ClearDraftParameter";
import updateParameter from "@store/Framework/Store/Greif/Pages/OrderHistory/Handlers/UpdateParameter";
import {
    useOrderHistoryDataView,
    useOrderHistoryState,
} from "@store/Framework/Store/Greif/Pages/OrderHistory/OrderHistoryHooks";
import FilterDrawerAndButton from "@store/Library/Components/FilterDrawerAndButton";
import OrderHistoryFilterFieldItemNumber from "@store/Library/Components/OrderHistory/OrderHistoryFilterFieldItemNumber";
import OrderHistoryFilterFieldOrderDateRange from "@store/Library/Components/OrderHistory/OrderHistoryFilterFieldOrderDateRange";
import OrderHistoryFilterFieldOrderNumber from "@store/Library/Components/OrderHistory/OrderHistoryFilterFieldOrderNumber";
import OrderHistoryFilterFieldPlant from "@store/Library/Components/OrderHistory/OrderHistoryFilterFieldPlant";
import OrderHistoryFilterFieldPoNumber from "@store/Library/Components/OrderHistory/OrderHistoryFilterFieldPoNumber";
import OrderHistoryFilterFieldRequestedDeliveryDateRange from "@store/Library/Components/OrderHistory/OrderHistoryFilterFieldRequestedDeliveryDateRange";
import OrderHistoryFilterFieldShipTo from "@store/Library/Components/OrderHistory/OrderHistoryFilterFieldShipTo";
import OrderHistoryFilterFieldStatus from "@store/Library/Components/OrderHistory/OrderHistoryFilterFieldStatus";
import OrderHistoryFilterFieldWebOrderNumber from "@store/Library/Components/OrderHistory/OrderHistoryFilterFieldWebOrderNumber";
import Heading, { HeadingPresentationProps } from "@store/Library/Components/Toolkit/Heading";
import QuickSearchField from "@store/Library/Components/QuickSearchField";
import { quickSearchAndFilterProps, QuickSearchAndFilterProps } from "@store/Themes/common/props/quickSearchAndFilter";
import React, { FC } from "react";

export interface OrderHistoryHeaderStyles extends QuickSearchAndFilterProps {
    heading?: HeadingPresentationProps;
}

export const orderHistoryHeaderStyles: OrderHistoryHeaderStyles = {
    heading: {
        variant: "h1",
    },
    quickSearchWrapper: quickSearchAndFilterProps.quickSearchWrapper,
    quickSearchField: quickSearchAndFilterProps.quickSearchField,
    filterDrawerAndButton: quickSearchAndFilterProps.filterDrawerAndButton,
};

const styles = orderHistoryHeaderStyles;

const OrderHistoryHeader: FC = () => {
    const dispatch = useAppDispatch();
    const { isLoading } = useOrderHistoryDataView();
    const { canApplyFilters, canClearFilters, filterCount, parameter } = useOrderHistoryState();

    const handleSearch = (value: string) => {
        dispatch(updateParameter({ search: value.trim() || undefined }));
    };

    return (
        <>
            <Heading {...styles.heading} usePageTitle={true} />
            <StyledWrapper {...styles.quickSearchWrapper}>
                <QuickSearchField
                    {...styles.quickSearchField}
                    placeholder={translate("Search by PO #, Greif Order # or Item #")}
                    initialValue={parameter.search ?? ""}
                    onSearch={handleSearch}
                />
                <FilterDrawerAndButton
                    {...styles.filterDrawerAndButton}
                    filterCount={filterCount}
                    filterButtonProps={{
                        disabled: isLoading,
                    }}
                    drawerProps={{
                        handleClose: () => dispatch(cancelDraftParameterChanges()),
                        headline: translate("Filter Orders"),
                    }}
                    applyButtonProps={{
                        disabled: !canApplyFilters,
                        onClick: () => dispatch(applyDraftParameter()),
                    }}
                    clearButtonProps={{
                        disabled: !canClearFilters,
                        onClick: () => dispatch(clearDraftParameter()),
                    }}
                >
                    <OrderHistoryFilterFieldShipTo />
                    <OrderHistoryFilterFieldPoNumber />
                    <OrderHistoryFilterFieldOrderNumber />
                    <OrderHistoryFilterFieldWebOrderNumber />
                    <OrderHistoryFilterFieldItemNumber />
                    <OrderHistoryFilterFieldPlant />
                    <OrderHistoryFilterFieldStatus />
                    <OrderHistoryFilterFieldOrderDateRange />
                    <OrderHistoryFilterFieldRequestedDeliveryDateRange />
                </FilterDrawerAndButton>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: OrderHistoryHeader,
    definition: {
        displayName: "Header (V2)",
        group: "Order History",
        allowedContexts: [constants.pageType.orderHistory],
        fieldDefinitions: [],
    },
};

export default widgetModule;
